import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "flex items-center mb-4" };
const _hoisted_2 = { class: "admin-form panel-form" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "mt-2" };
const _hoisted_5 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_6 = { class: "mt-2" };
const _hoisted_7 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_8 = {
    key: 0,
    class: "admin-form panel-form"
};
const _hoisted_9 = { class: "form-group" };
const _hoisted_10 = { class: "mt-2" };
const _hoisted_11 = ["value"];
const _hoisted_12 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_13 = {
    key: 1,
    class: "admin-form panel-form"
};
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = { class: "mt-2" };
const _hoisted_16 = ["value"];
const _hoisted_17 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_18 = {
    key: 1,
    class: "text-lg font-medium text-slate-900"
};
const _hoisted_19 = { class: "flex mt-6 justify-end" };
const _hoisted_20 = { class: "ml-1" };
const _hoisted_21 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_form_message = _resolveComponent("form-message");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Invite User", -1)),
            _createElementVNode("nav", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.form.navigation.goBack && _ctx.form.navigation.goBack(...args))),
                    type: "button",
                    class: "alt"
                }, "Go Back")
            ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "top-help-block" }, [
            _createElementVNode("div", null, [
                _createElementVNode("span", { class: "text-brand-600" }, "*"),
                _createTextVNode(" denotes required field ")
            ])
        ], -1)),
        _createElementVNode("form", {
            action: "#",
            method: "post",
            enctype: "multipart/form-data",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.form.invite()), ["prevent"]))
        }, [
            _createElementVNode("section", _hoisted_2, [
                _cache[9] || (_cache[9] = _createElementVNode("aside", null, [
                    _createElementVNode("h2", { class: "font-medium text-lg" }, "Personal Information"),
                    _createElementVNode("p", null, " User account and privacy settings. ")
                ], -1)),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('name') }])
                    }, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "name" }, [
                            _createTextVNode("Name"),
                            _createElementVNode("span", { class: "req-asterisk" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "name",
                                id: "name",
                                required: "",
                                "aria-required": "true",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.form.data.name) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.form.data.name]
                            ])
                        ]),
                        (_ctx.form.fieldHasErrors('name'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.form.getFieldError('name')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('email') }])
                    }, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "email" }, [
                            _createTextVNode("Email"),
                            _createElementVNode("span", { class: "req-asterisk" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _withDirectives(_createElementVNode("input", {
                                type: "email",
                                name: "email",
                                id: "email",
                                required: "",
                                "aria-required": "true",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.form.data.email) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.form.data.email]
                            ])
                        ]),
                        (_ctx.form.fieldHasErrors('email'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.form.getFieldError('email')), 1))
                            : _createCommentVNode("", true)
                    ], 2)
                ])
            ]),
            (_ctx.$props.app.auth.role === 'admin')
                ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                    _cache[11] || (_cache[11] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Account Security"),
                        _createElementVNode("p", null, " User authorization settings ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('role') }])
                        }, [
                            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "role" }, "Role", -1)),
                            _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("select", {
                                    name: "role",
                                    id: "role",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.data.role) = $event))
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                                        return (_openBlock(), _createElementBlock("option", { value: role }, _toDisplayString(role), 9, _hoisted_11));
                                    }), 256))
                                ], 512), [
                                    [_vModelSelect, _ctx.form.data.role]
                                ])
                            ]),
                            (_ctx.form.fieldHasErrors('role'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.form.getFieldError('role')), 1))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ]))
                : _createCommentVNode("", true),
            (_ctx.form.data.role !== 'admin')
                ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                    _cache[14] || (_cache[14] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Account Information"),
                        _createElementVNode("p", null, "Your company/organisation settings.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_14, [
                        (_ctx.form.isAdminUser())
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('name') }])
                            }, [
                                _cache[13] || (_cache[13] = _createElementVNode("label", { for: "account" }, [
                                    _createTextVNode("Account"),
                                    _createElementVNode("span", { class: "req-asterisk" }, "*")
                                ], -1)),
                                _createElementVNode("div", _hoisted_15, [
                                    _withDirectives(_createElementVNode("select", {
                                        name: "account",
                                        id: "account",
                                        required: "",
                                        "aria-required": "true",
                                        autocomplete: "off",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.form.data.account) = $event))
                                    }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, "Select Account", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.accounts, (account) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                value: account.slug
                                            }, _toDisplayString(account.name), 9, _hoisted_16));
                                        }), 256))
                                    ], 512), [
                                        [_vModelSelect, _ctx.form.data.account]
                                    ])
                                ]),
                                (_ctx.form.fieldHasErrors('account'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.form.getFieldError('account')), 1))
                                    : _createCommentVNode("", true)
                            ], 2))
                            : (_openBlock(), _createElementBlock("h2", _hoisted_18, _toDisplayString(_ctx.$props.app.auth.account), 1))
                    ])
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_form_message, { form: _ctx.form }, null, 8, ["form"]),
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                        type: "submit",
                        disabled: _ctx.form.isSubmitting()
                    }, "Invite User", 8, _hoisted_21)
                ])
            ])
        ], 32)
    ], 64));
}
